import {
  collection,
  doc,
  query,
  orderBy,
  updateDoc,
  type DocumentData,
  type FirestoreDataConverter,
  type Query,
  type WithFieldValue,
} from 'firebase/firestore';

import { firestore } from './config';
import { USE_API, api, apiQuery } from '@/services/api/client';
import type { Timestamp } from 'firebase/firestore';

export interface SalidaAlmacen {
  id: string;
  productoId: string;
  productoNombre: string;
  productoPresentacion: string | null;
  coleccion: 'productos_venta' | 'insumos_internos';
  cantidad: number;
  destino: string;
  destinoNombre: string;
  motivo: string | null;
  fecha: Timestamp;
  autorUid: string;
  autorNombre: string;
  createdAt: Timestamp;
}

const conv: FirestoreDataConverter<SalidaAlmacen> = {
  toFirestore(d: WithFieldValue<SalidaAlmacen>): DocumentData {
    return d as DocumentData;
  },
  fromFirestore(snap, options) {
    const data = snap.data(options) as Omit<SalidaAlmacen, 'id'>;
    return { id: snap.id, ...data };
  },
};

export const salidasCollection = collection(firestore, 'salidas_almacen').withConverter(conv);

export const salidasQuery: any = USE_API
  ? apiQuery('/salidas_almacen', { _order: '-fecha' })
  : query(salidasCollection, orderBy('fecha', 'desc'));

/** Edita el área (destino) o el motivo de una salida ya registrada. */
export async function actualizarSalida(
  id: string,
  patch: { destino?: string; destinoNombre?: string; motivo?: string | null },
): Promise<void> {
  if (USE_API) {
    await api.patch(`/salidas_almacen/${id}`, patch);
    return;
  }
  await updateDoc(doc(salidasCollection, id), patch as any);
}
